import React, { useRef } from "react";
import { Card, Button, Row, Col } from "react-bootstrap";
import { useNavigate } from "react-router";
import CreditForm, { CreditFormHandle } from "../CreditForm/CreditForm";
import { PaymentCreditOption } from "../types/ProjectCredit";
import useStyles from "../styles/useStyles";

interface Props {
  projectId: string;
  permission: string;
  projectStatus: string;
  paymentCredits: PaymentCreditOption[];
}

const New: React.FC<Props> = ({
  projectId,
  permission,
  projectStatus,
  paymentCredits,
}) => {
  const navigate = useNavigate();
  const submitRef = useRef<CreditFormHandle>(null);
  const styles = useStyles();

  return (
    <div className={styles.page}>
      <Card className={styles.card}>
        <Card.Header className={styles.cardHeader}>
          <Row className={styles.headerRow}>
            <Col sm={1}>
              <Button
                className="btnSeawhite"
                onClick={() =>
                  navigate(`/projects/${projectId}/project_credits`, {
                    state: null,
                  })
                }
              >
                Cancel
              </Button>
            </Col>
            <Col className={styles.title} sm={9}>
              Add Payment Credit
            </Col>
            {(permission === "create" || permission === "manage") &&
              projectStatus === "building" && (
              <Col>
                <Button
                  className="squareGreenButton floatRight"
                  onClick={() => submitRef.current?.saveCredit()}
                >
                  Save
                </Button>
              </Col>
            )}
          </Row>
        </Card.Header>
        <hr className={styles.hr} />
        <Card.Body>
          <CreditForm
            ref={submitRef}
            projectId={projectId}
            paymentCredits={paymentCredits}
          />
        </Card.Body>
      </Card>
    </div>
  );
};

export default New;
